import moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import type { FileLockData } from '../../Models/FileLockData';
import LockType from '../../Models/LockType';
import { DobButton } from '@dedalusdiit/dob-components';
import { Dialog, DialogButtons, DialogContent, DialogTitle } from '../Dialog/Dialog';

function FileLockDialog(
    { isOpen, lockData, onOk, onUnlock }:
    Readonly<{ isOpen: boolean; lockData: FileLockData; onOk: React.MouseEventHandler<HTMLButtonElement>; onUnlock: React.MouseEventHandler<HTMLButtonElement> }>,
): React.ReactElement {
    const { t } = useTranslation();

    return (
        <Dialog open={isOpen}>
            <DialogTitle>{t('UnableToEdit')}</DialogTitle>
            <DialogContent>
                <>
                    {t('CurrentlyLocked')}
                    {' '}
                    <b>{lockData.LockedBy}</b>
                    <br />
                    {t('At')}
                    {' '}
                    {moment(lockData.LockedOn).format('DD/MM/YYYY hh:mm:ss A')}
                    {' '}
                    (
                    {lockData.LockedOnHost}
                    )
                    <br />
                    {t('TryAgainLater')}
                </>
            </DialogContent>
            <DialogButtons>
                <>
                    <DobButton onClick={onOk}>{t('Ok')}</DobButton>
                    { lockData.Type === LockType.Order && <DobButton onClick={onUnlock} color="danger">{t('Unlock')}</DobButton> }
                </>
            </DialogButtons>
        </Dialog>
    );
}

export default FileLockDialog;
